// header 捲動收合門檻 (px)，需與 Scripts/Allmenu_layoutindex.js 的 scrollEvent 收合行為一致
const HEADER_SHRINK_THRESHOLD = 80;

export type ScrollToHeaderAnchorOptions = {
    additionalOffset?: number;
    stickyElement?: HTMLElement | null;
};

/**
 * 量測 header 收合後的真實高度：暫時套用收合狀態 (header_area1 隱藏、mainmenu 置頂)，量測後還原
 */
const getCollapsedHeaderHeight = (header: HTMLElement): number => {
    const area1 = header.querySelector<HTMLElement>('.header_area1');
    const mainmenu = header.querySelector<HTMLElement>('.mainmenu');
    const area1InlineDisplay = area1 ? area1.style.display : '';
    const mainmenuHadFixedTop =
        mainmenu?.classList.contains('fixed_top') ?? false;

    if (area1) {
        area1.style.display = 'none';
    }
    mainmenu?.classList.add('fixed_top');

    const collapsedHeight = header.offsetHeight;

    if (area1) {
        area1.style.display = area1InlineDisplay;
    }
    // 僅還原本函式新增的 fixed_top，避免拔掉捲動事件已合法套用的狀態
    if (mainmenu && !mainmenuHadFixedTop) {
        mainmenu.classList.remove('fixed_top');
    }

    return collapsedHeight;
};

/**
 * 計算置頂元素尚未包含在 header 內的高度，並保留 sticky-zone 展開過程中的差額
 */
const getStickyElementOffset = (
    header: HTMLElement | null,
    stickyElement?: HTMLElement | null
): number => {
    if (!stickyElement) return 0;

    const stickyZone = stickyElement.closest<HTMLElement>('.sticky-zone');
    const includedHeight =
        stickyZone && header?.contains(stickyZone)
            ? stickyZone.offsetHeight
            : 0;

    return Math.max(0, stickyElement.offsetHeight - includedHeight);
};

/**
 * 平滑捲動到錨點並對齊在 header 下方，
 * 捲動距離超過收合門檻時，桌機版 header_area1 會收合，改以收合後高度對齊；
 * 數字參數為額外佔位高度 (px)；options.stickyElement 會補上捲動後進入
 * sticky-zone、但尚未包含在 header 量測結果中的高度
 */
export const scrollToHeaderAnchor = (
    target: string | Element,
    offsetZone: number | ScrollToHeaderAnchorOptions = 0
): void => {
    const el =
        typeof target === 'string' ? document.querySelector(target) : target;
    if (!el) return;

    const header = document.querySelector<HTMLElement>('.header');
    const absoluteTop = window.scrollY + el.getBoundingClientRect().top;
    let headerHeight = header?.offsetHeight ?? 0;
    const options =
        typeof offsetZone === 'number'
            ? { additionalOffset: offsetZone }
            : offsetZone;
    const additionalOffset =
        (options.additionalOffset ?? 0) +
        getStickyElementOffset(header, options.stickyElement);

    if (header && absoluteTop - headerHeight > HEADER_SHRINK_THRESHOLD) {
        const area1 = header.querySelector<HTMLElement>('.header_area1');
        const isMobile = document.body.classList.contains('mobile');
        if (!isMobile && area1 && area1.offsetHeight > 0) {
            headerHeight = getCollapsedHeaderHeight(header);
        }
    }

    window.scrollTo({
        top: absoluteTop - headerHeight - additionalOffset,
        behavior: 'smooth',
    });
};
